/* eslint-disable @typescript-eslint/naming-convention */
import { t } from 'i18next';
type translationFunctionType = (name: string) => string;
export const __: translationFunctionType = t;
